<template>
  <div>
    <div class="text-xl font-black py-2 mt-8">9. Territory Review</div>
    <div class="font-black py-2">Performance Matrices</div>
    <div>
      <div class="py-2">Screen grab the map of the offices territories and upload it in here.</div>
      <panel class="img-div" v-if="form.attachment && form.attachment.territory_review_img">
        <img :src="form.attachment.territory_review_img" class="w-full pb-2 object-cover bg-gray-100 cursor-pointer" @click="ReviewImgVisible=true" />
        <modal v-if="ReviewImgVisible" @leave="ReviewImgVisible=false"  modalClass="max-width-full">
          <img :src="form.attachment.region_landscape_img" />
        </modal>
      </panel>
      <panel v-else>
        <div>
          <img src="https://via.placeholder.com/400x200.png?text=No+office+territories+review+image">
        </div>
      </panel>
    </div>
    <div class="flex flex-wrap">
      <div v-for="(area,i) in review.officeDistricts" :key="i" class="bg-grey p-2 m-2" v-if="area.postcode_area">{{area.postcode_area}}</div>
    </div>

    <!-- Sub section -->
    <div class="mt-8 pt-2">
      <div class="font-black text-lg py-2">Territory Discussion Points</div>
      <div v-for="(question, index) in form.questions[page][sectionStart]" :key="index">
        <review-question-component v-model="form.questions[page][sectionStart][index]" :showMandatory="showMandatory"></review-question-component>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewQuestionComponent from '@/components/AnnualReview/ReviewQuestionComponent'
import { v2Api } from '@/http'

export default {
  components: { ReviewQuestionComponent },
  props: ['value', 'review', 'page', 'sectionStart', 'showMandatory'],
  data () {
    return {
      form: this.value,
      ReviewImgVisible: false
    }
  },
  mounted () {
  },
  methods: {
    uploadFile (files, fileType) {
      this.errors = []
      let uploadFile = null
      if (files !== null) {
        uploadFile = files[0]
      } else if (!uploadFile) {
        return
      }
      // validate logo type
      let valid = false
      if (uploadFile.type === 'image/png' || uploadFile.type === 'image/jpeg' || uploadFile.type === 'image/jpg') {
        valid = true
      }

      if (!valid) {
        this.errors[fileType] = 'Upload file type invalid'
        return
      }

      var data = new FormData()
      data.append('_method', 'PUT')
      data.append('file', uploadFile)
      data.append('type', fileType)

      v2Api.post(`/annual-reviews/${this.annualReview.id}/uploadFile`, data).then((response) => {
        // update preview image
        if (response.data.url) {
          this.form.attachment[fileType] = response.data.url
        } else {
          this.errors[fileType] = response.errors.message
        }
      }, (errors) => {
        this.errors = errors
      })
    }
  }
}
</script>
